export default "__VITE_ASSET__yQ82Qm$Z__"